import { gql } from '@apollo/client';

export const GET_ENROLLED_PROGRAMS = gql`
  query GetEnrolledPrograms($userId: Int4!) {
    enrolledPrograms: programs(
      where: {
        programEnrollments: { userId: { _eq: $userId } }
      }
    ) {
      id
      name
      image
      programCoursesAggregate {
        agg_count
      }
    }
  }
`;
